import { createTheme, ThemeProvider } from '@mui/material';
import { esES } from '@mui/material/locale';
import { ContainerProvider } from 'brandi-react';
import { container } from './setup/brandi';
import Router from './setup/router';

function App() {
  const theme = createTheme(
    {
      palette: {
        primary: {
          main: '#256FB5'
        },
        secondary: {
          main: '#26B1FF'
        }
      }
    },
    esES
  );

  return (
    <ContainerProvider container={container}>
      <ThemeProvider theme={theme}>
        <Router />
      </ThemeProvider>
    </ContainerProvider>
  );
}

export default App;
